<div v-if="isLoggedIn && showToolbar" class="tt-c-user-toolbar tt-u-spacing--left--sm">
  <div v-if="isLoggedIn" class="tt-c-user-toolbar__name">{{ formattedUsername }}</div>
  <tt-menu v-if="isLoggedIn && menuItems">
    <tt-button slot="menuTrigger" type="icon" class="tt-c-user-toolbar__menu-trigger" :aria-label="$msg('userToolbar.optionsMenuLabel')">
      <tt-icon name="more-h" size="sm"></tt-icon>
    </tt-button>
    <tt-menu-list class="tt-c-user-toolbar__menu-list" :menuItems="menuItems" @menuItemSelected="menuItemSelected"></tt-menu-list>
  </tt-menu>
</div>



// WEBPACK FOOTER //
// ./src/components/user-toolbar/user-toolbar-m1.html